'use client';

import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { cn } from '@/utils/cn';
import remarkStrikethrough from './remarkStrikethrough';

type MarkdownContentProps = {
  children: string;
  className?: string;
};

const MarkdownContent = ({ children, className }: MarkdownContentProps) => {
  return (
    <div className={cn('prose prose-invert max-w-full', className)}>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkStrikethrough]}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownContent;
